import { render, staticRenderFns } from "./AcctSufHelpList.vue?vue&type=template&id=0720644d&"
import script from "./AcctSufHelpList.vue?vue&type=script&lang=js&"
export * from "./AcctSufHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports